import { render, staticRenderFns } from "./ProjectPermissionCreate.vue?vue&type=template&id=1ddb28f8&"
import script from "./ProjectPermissionCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectPermissionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports